import { Fragment } from 'react';
import LearningContinuumCards from './LGRow/LCCards';
import { Skeleton } from '@mui/material';
import PaperBase from '../../Paper/PaperBase';

const LoadingLearningGrowth = ({ classUlInfo, direction = 'row', size = 35, currentCurriculum }) => {
  const lcs = Array.from({ length: 30 }, (_, index) => ({
    _id: `lc-${index}`,
    classes: [{ _id: `class-${index}` }],
    developmentalRubrics: [{ _id: `ul-${index}`, name: `Unit ${index + 1}` }],
    version: index + 1,
    ulId: `ul-${index}`,
    classId: `class-${index}`
  }));
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {};
  const levelsRender = currentCurriculum?.levels?.sort((a, b) => direction === 'row' ? a.position - b.position : b.position - a.position) || [];

  return (
    <div className={['py-1 flex gap-1 w-fit', direction === 'row' ? 'w-fit' : 'flex-col '].join(' ')}>
      {direction === 'row' && (
        <LearningContinuumCards
          classUlInfo={classUlInfo}
          size={size}
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          isLoading={true}
          direction={direction}
        />
      )}
      {levelsRender?.map((item, index) => (
        <Fragment key={`granular-steps-level-${item._id}-index-${index}`}>
          <div
            key={`granular-steps-loading-${item._id}-gs-${item}`}
            className={`flex ${direction === 'row' ? 'flex-col' : 'w-full'} flex-nowrap gap-1`}
          >
            <PaperBase
              backgroundColor={minMarking.primaryColor}
              color={minMarking.secondaryColor}
              children={item.code}
              // className={`font-bold sticky z-10 ${direction === 'row' ? ' top-0' : 'left-0 '}`}
              className={`font-bold sticky z-10 px-2 text-ellipsis ${
                direction === 'row' ? ' top-0' : 'left-0 min-w-100px max-w-100px  py-4'
              }`}
              style={{
                width: size,
                // height: size,
                // fontSize: 9
                height: direction === 'row' ? size : 'auto',
                fontSize: direction === 'row' ? '1.125rem' : 'auto'
              }}
            />
            {lcs.map((lc, ilc) => (
              <Skeleton
                variant='rounded'
                key={`granular-steps-loading-${item._id}-lc-${lc._id}-ilc-${ilc}`}
                className={direction === 'row' ? 'p-2' : 'px-2 py-4'}
                style={{
                  width: direction === 'row' ? size : '180px',
                  height: direction === 'row' ? size : 'auto',
                  fontSize: direction === 'row' ? 9 : 'auto'
                }}
              />
            ))}
          </div>
        </Fragment>
      ))}
      {/* {direction === 'column' && (
        <LearningContinuumCards
          classUlInfo={classUlInfo}
          size={size}
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          isLoading={true}
          direction={direction}
        />
      )} */}
    </div>
  );
};

export default LoadingLearningGrowth;
